import { graphql } from "~/gql";

export const TOGGLE_INCLUDE_IN_PROPOSAL = graphql(/* GraphQL */ `
  mutation ToggleIncludeInProposal($include: Boolean!, $toggleIncludeInProposalId: Float!) {
    toggleIncludeInProposal(include: $include, id: $toggleIncludeInProposalId) {
      id
      includeInProposalOutput
    }
  }
`);
